import { useState, useEffect } from 'react';
import { getAuditLogs, getAuditDetails, downloadAuditLogs } from '../../../Config/api';
// import { getAuditLogs, getAuditDetails, downloadAuditLogs } from '../utils/api';

export const useAuditTrail = () => {
    const [auditLogs, setAuditLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [actionFilter, setActionFilter] = useState('All Actions');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [slidingPanel, setSlidingPanel] = useState({
        isOpen: false,
        data: null,
        loading: false
    });

    const fetchAuditLogs = async () => {
        setLoading(true);
        try {
            const params = {
                page: currentPage,
                limit: rowsPerPage,
                search: searchTerm,
                actionType: actionFilter !== 'All Actions' ? actionFilter : ''
            };

            const data = await getAuditLogs(params);
            setAuditLogs(data.data || []);
            setTotalRecords(data.totalRecords || 0);
        } catch (error) {
            setMessage({ text: `Error: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const fetchAuditDetails = async (auditId) => {
        try {
            setSlidingPanel({ isOpen: true, data: null, loading: true });
            document.body.style.overflow = 'hidden';

            const data = await getAuditDetails(auditId);

            if (data.success) {
                setSlidingPanel({ isOpen: true, data: data.data, loading: false });
            } else {
                setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
            }
        } catch (error) {
            setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
        }
    };

    const closeSlidingPanel = () => {
        setSlidingPanel({ isOpen: false, data: null, loading: false });
        document.body.style.overflow = 'unset';
    };

    const downloadExcel = async () => {
        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const blob = await downloadAuditLogs('xlsx');
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const date = new Date().toISOString().split('T')[0];
            link.download = `audit-trail-${date}.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setMessage({ text: 'Downloaded successfully!', type: 'success' });
            setTimeout(() => setMessage({ text: '', type: '' }), 3000);

        } catch (error) {
            setMessage({ text: `Failed: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAuditLogs();
    }, [currentPage, rowsPerPage, searchTerm, actionFilter]);

    return {
        auditLogs,
        loading,
        searchTerm,
        setSearchTerm,
        actionFilter,
        setActionFilter,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalRecords,
        message,
        slidingPanel,
        fetchAuditDetails,
        closeSlidingPanel,
        downloadExcel
    };
};